import React, { useState } from 'react';
import statusColors from './StatusColors';

/* Todo: generate wrapper component for all bottom elements */

function StatusColorLegend() {
  const [isVisible, setIsVisible] = useState(false); // state to control visibility

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  return (
    <div
      className="fixed bottom-0 right-0 p-4 m-4 shadow-lg rounded-lg z-20"
      style={{
        /* Todo: use general class */
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      }}
    >
      <div className="flex justify-between items-center">
        <span className="text-md font-bold mb-2 block">Status Colors</span>
        <button
          type="button"
          onClick={toggleVisibility}
          className="text-sm p-1 rounded-full bg-transparent hover:bg-gray-200"
          style={{
            /* Todo: use general class */
            backdropFilter: 'blur(5px)',
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
          }}
        >
          <span className="arrow">{isVisible ? '⇵' : '⇅'}</span> {/* Toggle arrow */}
        </button>
      </div>
      {isVisible && ( // Render content only when isVisible is true
        <ul>
          {statusColors.map((statusObj, index) => (
            <li key={index} className="flex items-center mb-1">
              <span className={`h-3 w-3 rounded-full ${statusObj.color} mr-2`}></span>
              {statusObj.statuses.join(' / ')}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default StatusColorLegend;
